<!--
/*******************************************************************************
*@ 컴포넌트명   : VuelidateForm.vue
*@ 컴포넌트설명 : validation 공통컴포넌트 - 오류 표현용
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div>
    <slot />
    <div v-if="hasErrors">
      <div class="validate" v-for="(error, i) in activeErrorMessages" :key="i" v-html="error"></div>
    </div>
  </div>
</template>
<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
export default {
  mixins: [singleErrorExtractorMixin],
};
</script>